<style>
.padding_10 {
  padding: 0px !important;
}
</style>

<template>
  <div>
    <!-- Form Section -->
    <div v-if="submit_loader" style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; padding-top: 25%; background-color: rgba(255, 255, 255, 0.31);">
      <div class="text-xs-center" large></div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form data-vv-scope="CreateWinners" @submit.prevent="validateBeforeSubmit('CreateWinners')">
              <input type="hidden" name="id" v-model="winners_object.id" />
              <v-card-text>
                <v-layout row wrap>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Users <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-autocomplete
                      :items="users_list"
                      :search-input.sync="userSearch"
                      :loading="userSearchLoading"
                      name="user_id"
                      v-model="winners_object.user_id"
                      label="Search by name, mobile or email"
                      v-validate="'required'"
                      :error-messages="errors.collect('CreateWinners.user_id')"
                      clearable
                      solo
                      flat
                      no-filter
                      data-vv-as="Users"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Date <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-menu ref="menuStart" v-model="winners_object.menu_start_date" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="winners_object.date"
                            name="date"
                            v-validate="'required'"
                            data-vv-scope="CreateWinners"
                            :error-messages="errors.collect('CreateWinners.date')"
                            label="Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            flat
                            data-vv-as="Date"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="winners_object.date" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="winners_object.date = null">Clear</v-btn>
                          <v-btn text color="primary" @click="winners_object.menu_start_date = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menuStart.save(winners_object.date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="submit_loader" type="submit">
                  {{ isEditMode ? 'Update' : 'Create' }}
                </v-btn>
                <v-btn flat small @click="resetWinnersObject">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- List Section -->
      <div class="mt-3">
        <h4>Total {{ total_items }}</h4>
        <v-data-table
          no-results-text="Loading... Please wait"
          :items="winners_list"
          :pagination.sync="pagination"
          :loading="loaders.winners_list_loader"
          :total-items="total_items"
          :rows-per-page-items="[10, 20, 50, 100]"
          class="elevation-1"
        >
          <template v-slot:headers="props">
            <tr>
              <th v-for="header in headers" :key="header.text">
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template v-slot:items="props">
            <tr>
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.user_name }}</td>
              <td>{{ props.item.date }}</td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-layout v-if="loaders.winners_list_loader" justify-center>
              Loading... Please wait
            </v-layout>
            <v-layout v-else justify-center>
              No data available
            </v-layout>
          </template>
        </v-data-table>
      </div>

      <v-snackbar :color="snackBar.color" :top="snackBar.top" :bottom="snackBar.bottom" :left="snackBar.left"
        :right="snackBar.right" v-model="snackBar.show">
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "Winners",

  data() {
    const today = new Date().toISOString().substr(0, 10);

    return {
      valid: false,
      submit_loader: false,
      users_list: [],
      userSearch: null,
      userSearchQuery: '',
      userSearchLoading: false,
      userSearchTimer: null,

      winners_object: {
        id: null,
        user_id: null,
        date: null,
        menu_start_date: false,
      },

      // List data
      winners_list: [],
      total_items: 0,

      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "",
        descending: true,
      },

      loaders: {
        winners_list_loader: false,
      },

      headers: [
        { text: "Sr", value: "" },
        { text: "Name", value: "user_name" },
        { text: "Date", value: "date" },
      ],

      snackBar: {
        show: false,
        message: "",
        color: "",
        top: true,
        right: true,
      },
    };
  },

  computed: {
    isEditMode() {
      return !!this.winners_object.id;
    },
  },

  watch: {
    userSearch(val) {
      clearTimeout(this.userSearchTimer);
      this.userSearchTimer = setTimeout(() => {
        this.userSearchQuery = val || '';
        this.getWinnersList();
      }, 400);
    },
    pagination: {
      handler() {
        this.getWinnersList();
      },
      deep: true,
    },
  },

  mounted() {
    this.current_date = moment().format("YYYY-MM-DD");
    this.getWinnersList();
  },

  methods: {

    resetWinnersObject() {
      this.winners_object = {
        id: null,
        user_id: null,
        date: null,
        menu_start_date: false,
      };
    },

    validateBeforeSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        } else {
          this.snackBar.message = "Please fill all required fields correctly.";
          this.snackBar.show = true;
        }
      });
    },

    CreateWinners() {
      this.submit_loader = true;

      const winnersId = this.winners_object.id ? String(this.winners_object.id).trim() : "";
      const isEdit = !!winnersId;

      if (this.isEditMode && !winnersId) {
        this.snackBar.message = "Winners ID is missing for update.";
        this.snackBar.color = "error";
        this.snackBar.show = true;
        this.submit_loader = false;
        return;
      }

      const payload = {
        ...(isEdit ? { id: winnersId } : {}),
        user_id: this.winners_object.user_id,
        date: this.winners_object.date,
      };

      axios.post(
        `${process.env.VUE_APP_API_URL}/api/v4/${isEdit ? 'update-winner-users' : 'insert-winner-users'}`,
        payload,
        { headers: this.$headers }
      )
        .then((response) => {
          if (response.data.status == 1) {
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
            this.resetWinnersObject();
            this.getWinnersList();
          } else {
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .finally(() => {
          this.submit_loader = false;
        });
    },

    getWinnersList() {
      this.loaders.winners_list_loader = true;
      this.userSearchLoading = true;

      axios.post(
        `${process.env.VUE_APP_API_URL}/api/v4/get-winners-list`,
        {},
        {
          headers: this.$headers,
          params: {
            page: this.pagination.page,
            rowsPerPage: this.pagination.rowsPerPage,
            sortBy: this.pagination.sortBy,
            descending: this.pagination.descending,
            search: this.userSearchQuery || '',
          },
        }
      )
        .then((response) => {
          if (response.data.status == 1) {
            const payload = response.data || {};
            const paginatedData = payload.data || {};
            const list = Array.isArray(paginatedData.data) ? paginatedData.data : [];

            this.winners_list = list;
            this.total_items =
              paginatedData.total !== undefined
                ? Number(paginatedData.total)
                : payload.total !== undefined
                  ? Number(payload.total)
                  : this.winners_list.length;

            if (paginatedData.current_page && Number(paginatedData.current_page) !== this.pagination.page) {
              this.pagination.page = Number(paginatedData.current_page);
            }

            // Handle dropdown data
            const dropdownData = payload.enrolled_users_data || [];
            this.users_list = dropdownData.map((user) => ({
              text: `${user.first_name} ${user.last_name} (${user.mobile})`,
              value: user.id,
            }));
          }
        })
        .catch(() => {
          this.snackBar.message = "Something went wrong!";
          this.snackBar.show = true;
        })
        .finally(() => {
          this.loaders.winners_list_loader = false;
          this.userSearchLoading = false;
        });
    },
  },
};
</script>
